// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ExtractDatasetOutput } from "./ExtractDatasetOutput";
import {
  ExtractDatasetOutputFromJSON,
  ExtractDatasetOutputFromJSONTyped,
  ExtractDatasetOutputToJSON,
  ExtractDatasetOutputToJSONTyped,
} from "./ExtractDatasetOutput";
import type { ExtractDatasetInput } from "./ExtractDatasetInput";
import {
  ExtractDatasetInputFromJSON,
  ExtractDatasetInputFromJSONTyped,
  ExtractDatasetInputToJSON,
  ExtractDatasetInputToJSONTyped,
} from "./ExtractDatasetInput";

/**
 *
 * @export
 * @interface ExtractDatasetSchema
 */
export interface ExtractDatasetSchema {
  /**
   *
   */
  tag: ExtractDatasetSchemaTagEnum;
  /**
   *
   */
  inputs: ExtractDatasetInput;
  /**
   *
   */
  outputs: ExtractDatasetOutput;
}

/**
 * @export
 */
export const ExtractDatasetSchemaTagEnum = {
  ExtractDataset: "extract_dataset",
} as const;
export type ExtractDatasetSchemaTagEnum =
  (typeof ExtractDatasetSchemaTagEnum)[keyof typeof ExtractDatasetSchemaTagEnum];

/**
 * Check if a given object implements the ExtractDatasetSchema interface.
 */
export function instanceOfExtractDatasetSchema(value: object): value is ExtractDatasetSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "extract_dataset") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function ExtractDatasetSchemaFromJSON(json: any): ExtractDatasetSchema {
  return ExtractDatasetSchemaFromJSONTyped(json, false);
}

export function ExtractDatasetSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExtractDatasetSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: ExtractDatasetInputFromJSON(json["inputs"]),
    outputs: ExtractDatasetOutputFromJSON(json["outputs"]),
  };
}

export function ExtractDatasetSchemaToJSON(json: any): ExtractDatasetSchema {
  return ExtractDatasetSchemaToJSONTyped(json, false);
}

export function ExtractDatasetSchemaToJSONTyped(
  value?: ExtractDatasetSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: ExtractDatasetInputToJSON(value["inputs"]),
    outputs: ExtractDatasetOutputToJSON(value["outputs"]),
  };
}
